import { render } from "./CareerComp.vue?vue&type=template&id=e6d29c7c"
import script from "./CareerComp.vue?vue&type=script&lang=js"
export * from "./CareerComp.vue?vue&type=script&lang=js"

import "./CareerComp.vue?vue&type=style&index=0&id=e6d29c7c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__